<a *ngIf="customerId" [routerLink]="routerLink">{{ firstName }} {{ lastName }}</a>
<span *ngIf="!customerId" [class]="fallbackClass">{{ fallbackText }}</span>
